exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#uyh-app #uyh-home[data-v-0c17840b],.responsivesite #wrapper #uyh-app #uyh-home[data-v-0c17840b]{min-height:calc(100vh - 92px)}", ""]);

// exports
